// OMD-191: 메일 뷰어 외부 이미지 차단 예외(수신확인 추적 픽셀) origin 판별.
//
// conf/redux/services 에 의존하지 않는 순수 함수로 분리해 단위 테스트를 가볍게 유지한다.
// 실제 예외 origin 집합은 viewerExt.tsx 가 conf.SERVER.readReceiptApiURL 에서 파생해 주입한다.

// 크로스-환경 전달 메일(발신·수신 환경이 다른 edge case) 대비로 항상 포함하는 운영/개발 origin.
// 현재 환경 origin 은 buildReadReceiptAllowOrigins 가 conf 값에서 추가로 합집합한다.
export const READ_RECEIPT_FALLBACK_ORIGINS: readonly string[] = [
  'https://read-receipt.officemail.io',
  'https://dev-read-receipt.officemail.io',
]

/**
 * conf.SERVER.readReceiptApiURL 의 origin + 운영/개발 fallback origin 을 합집합한 예외 origin 목록.
 * readReceiptApiURL 이 미설정/파싱 실패면 fallback 만 사용한다.
 */
export function buildReadReceiptAllowOrigins(
  readReceiptApiURL: string | null | undefined,
): string[] {
  const origins = new Set<string>(READ_RECEIPT_FALLBACK_ORIGINS)
  if (readReceiptApiURL != null && readReceiptApiURL.length > 0) {
    try {
      origins.add(new URL(readReceiptApiURL).origin)
    } catch {
      /* 파싱 실패 시 fallback 만 사용 */
    }
  }
  return [...origins]
}

/**
 * src 가 수신확인 서버 origin 과 완전히 일치하면 예외(true), 아니면 외부 이미지(false).
 *
 * ⚠️ 반드시 동기(sync)로 동작한다 — NineNative.isExternalImageSrc 가 viewer 의 img hot-path 에서
 *    동기 boolean 을 요구하므로, 이 판별 로직도 동기여야 한다(네트워크/async 조회 금지).
 *
 * 접두어(startsWith) 매칭은 `https://read-receipt.officemail.io.attacker.com/...` 같은 도메인 경계
 * 우회를 허용하므로, `new URL(src).origin` 완전 일치로만 예외 처리한다. 파싱 불가 URL 은 외부로 간주.
 */
export function isReadReceiptOrigin(src: string, allowedOrigins: readonly string[]): boolean {
  try {
    return allowedOrigins.includes(new URL(src).origin)
  } catch {
    return false
  }
}
